import { gql } from 'urql';

export const TURNO_FIELDS = gql`
  fragment TurnoFields on Turno {
    id
    nombre
    descripcion
    horaEntrada
    horaSalida
    descansoMinutos
    aplicaFinesDeSemana
    sucursalId
    sucursalNombre
    activo
    creadoEn
  }
`;

export const ASIGNACION_TURNO_FIELDS = gql`
  fragment AsignacionTurnoFields on AsignacionTurno {
    id
    turnoId
    turnoNombre
    empleadoId
    empleadoNombre
    desde
    hasta
    estado
    sucursalId
    sucursalNombre
  }
`;

export const TURNOS_LIST = gql`
  query TurnosList($filters: TurnosFiltersInput, $pagination: PaginationInput, $order: TurnoOrderInput) {
    turnos(filters: $filters, pagination: $pagination, order: $order) {
      total
      pageInfo {
        page
        perPage
        totalItems
        totalPages
      }
      items {
        ...TurnoFields
      }
    }
  }
  ${TURNO_FIELDS}
`;

export const TURNO_BY_ID = gql`
  query TurnoById($id: ID!) {
    turno(id: $id) {
      ...TurnoFields
    }
  }
  ${TURNO_FIELDS}
`;

export const ASIGNACIONES_TURNOS_LIST = gql`
  query AsignacionesTurnosList($filters: AsignacionesTurnoFiltersInput, $pagination: PaginationInput, $order: AsignacionTurnoOrderInput) {
    asignacionesTurno(filters: $filters, pagination: $pagination, order: $order) {
      total
      pageInfo {
        page
        perPage
        totalItems
        totalPages
      }
      items {
        ...AsignacionTurnoFields
      }
    }
  }
  ${ASIGNACION_TURNO_FIELDS}
`;

export const ASIGNACION_TURNO_BY_ID = gql`
  query AsignacionTurnoById($id: ID!) {
    asignacionTurno(id: $id) {
      ...AsignacionTurnoFields
    }
  }
  ${ASIGNACION_TURNO_FIELDS}
`;

export const TURNO_CREATE = gql`
  mutation TurnoCreate($input: TurnoInput!) {
    turnoCreate(input: $input) {
      ...TurnoFields
    }
  }
  ${TURNO_FIELDS}
`;

export const TURNO_UPDATE = gql`
  mutation TurnoUpdate($id: ID!, $input: TurnoInput!) {
    turnoUpdate(id: $id, input: $input) {
      ...TurnoFields
    }
  }
  ${TURNO_FIELDS}
`;

export const TURNO_DELETE = gql`
  mutation TurnoDelete($id: ID!) {
    turnoDelete(id: $id)
  }
`;

export const ASIGNACION_TURNO_CREATE = gql`
  mutation AsignacionTurnoCreate($input: AsignacionTurnoInput!) {
    asignacionTurnoCreate(input: $input) {
      ...AsignacionTurnoFields
    }
  }
  ${ASIGNACION_TURNO_FIELDS}
`;

export const ASIGNACION_TURNO_UPDATE = gql`
  mutation AsignacionTurnoUpdate($id: ID!, $input: AsignacionTurnoInput!) {
    asignacionTurnoUpdate(id: $id, input: $input) {
      ...AsignacionTurnoFields
    }
  }
  ${ASIGNACION_TURNO_FIELDS}
`;

export const ASIGNACION_TURNO_DELETE = gql`
  mutation AsignacionTurnoDelete($id: ID!) {
    asignacionTurnoDelete(id: $id)
  }
`;
